module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="c-panneauDeroulant">    \r\n    <div class="cw-aujourdhui__btnsfonctionne"></div>\r\n    <div class="cw-aujourdhui__Compteurs cw-aujourdhui__Compteurs--separation">\r\n        <a class="cw-aujourdhui__Compteurs_link" href="javascript:void(0)">'+
((__t=(i18n.t('common:aujourdhui.linkCompteurs').toUpperCase()))==null?'':__t)+
'</a>        \r\n    </div>\r\n</div>';
}
return __p;
};
